import { render } from "./CreatorPanel.vue?vue&type=template&id=bdc633ea&scoped=true"
import script from "./CreatorPanel.vue?vue&type=script&lang=js"
export * from "./CreatorPanel.vue?vue&type=script&lang=js"

import "./CreatorPanel.vue?vue&type=style&index=0&id=bdc633ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc633ea"]])

export default __exports__